<template>
  <transition name="fade">
    <div class="fixed top-0 right-0 flex items-center justify-center w-full h-screen bg-gray-800/60 z-20" v-if="show">
      <div class="bg-gray-900 rounded-lg p-4" :class="large ? 'w-2/3' : 'w-1/3'" @click.stop>
        <h1 class="text-center text-white text-lg border-b border-gray-300 pb-4">{{ title }}</h1>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "VModal",
  props: ['show', 'title', 'large']
}
</script>

<style scoped>

</style>